import React from 'react';
import PropTypes from 'prop-types';

const ActivityGroupList = ({ groups, handleGroupItemSelected }) => (
  <div className="list-group mt-2">
    <a
      href="#"
      className="list-group-item list-group-item-action"
      style={{ padding: '5px' }}
      onClick={() => handleGroupItemSelected(null)}
    >
      <i className={`align-middle me-2 ri-list-check fs-16`}></i> Todas
    </a>
    {groups.map((item, key) => (
      <a
        href="#"
        className="list-group-item list-group-item-action"
        style={{ backgroundColor: item.bgcolor, color: item.txcolor, padding: '5px' }}
        key={key}
        onClick={() => handleGroupItemSelected(item)}
      >
        <i className={`align-middle ${item.icon} fs-16`}></i> {item.name}
      </a>
    ))}
  </div>
);

ActivityGroupList.propTypes = {
  groups: PropTypes.array.isRequired,
  handleGroupItemSelected: PropTypes.func.isRequired,
};

export default ActivityGroupList;
